export default {"src":"/_next/static/media/commingSoon.e6246fb0.svg","height":29,"width":146,"blurWidth":0,"blurHeight":0};